var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vh-container',{staticClass:"layout-container default"},[_c('div',{staticClass:"layout-main"},[(_vm.hasHeadBar)?_c('HeadBar'):_vm._e(),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }